export const isTruthy = (v: any) => !!v;
